import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcMail = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(1.5 4)",
		children: [/* @__PURE__ */ _jsx("path", { d: "m11.0988387 10.3846452c-.1981935.1238709-.4211613.1734193-.6193548.1734193-.1981936 0-.4211613-.0495484-.61935487-.1734193l-9.86012903-6.02012907v8.00206447c0 1.7094194 1.38735484 3.0967742 3.09677419 3.0967742h14.79019351c1.7094194 0 3.0967742-1.3873548 3.0967742-3.0967742v-8.00206447z" }), /* @__PURE__ */ _jsx("path", {
			d: "m17.8869677.00425806h-14.79019351c-1.46167742 0-2.70038709 1.04051613-2.99767742 2.42787097l10.40516133 6.34219355 10.3803871-6.34219355c-.2972904-1.38735484-1.536-2.42787097-2.9976775-2.42787097z",
			opacity: .48
		})]
	})
});
export default SvgIcMail;
